import { render, staticRenderFns } from "./STEP3.vue?vue&type=template&id=04548386&scoped=true&"
import script from "./STEP3.vue?vue&type=script&lang=js&"
export * from "./STEP3.vue?vue&type=script&lang=js&"
import style0 from "./STEP3.vue?vue&type=style&index=0&id=04548386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04548386",
  null
  
)

export default component.exports